import React, { useState, useEffect, createRef } from "react";
import {
  makeStyles,
  Button,
  Box,
  DialogActions,
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  withStyles,
  Slide,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import MuiDialogTitle from "@material-ui/core/DialogTitle";

import MaterialTable from "material-table";
import { useDispatch, useSelector } from "react-redux";

import { fetchUnit } from "src/redux/actions/reference.action";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 800,
    padding: 1,
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    overflowX: "auto",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UnitModalComponent({ open, handleClose, handleAdd }) {
  const classes = useStyles();

  const dispatch = useDispatch();

  const { units } = useSelector((state) => state.referenceReducer);

  const [rowSelect, setRowSelect] = useState({
    tableRef: createRef(),
    selected: true,
    selectedRowId: null,
    c: "blue",
    currentRow: {},
  });

  useEffect(() => {
    if (open) {
      dispatch(fetchUnit());
    }
    return () => {};
  }, [open]);

  return (
    <div className={classes.modal}>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        TransitionComponent={Transition}
        fullWidth
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Choose Unit Type
        </DialogTitle>
        <DialogContent dividers>
          <Box display="flex" component="div" flexDirection="column">
            <Box>
              <MaterialTable
                title
                columns={[
                  {
                    title: "No",
                    render: (rowData) => rowData.tableData.id + 1,
                  },
                  {
                    title: "Code",
                    field: "REF_CODE",
                  },
                  {
                    title: "Name",
                    field: "REF_NAME",
                  },
                ]}
                data={units.data}
                isLoading={units.isLoading}
                options={{
                  pageSize: 10,
                  detailPanelType: "single",
                  rowStyle: (rowData) => {
                    let selected =
                      rowSelect.selectedRow &&
                      rowSelect.selectedRow.tableData.id ===
                        rowData.tableData.id;
                    return {
                      backgroundColor: selected ? "grey" : "#FFF",
                      color: selected ? "#e0dd1f !important" : "#000",
                    };
                  },
                }}
                onRowClick={(evt, selectedRow) => setRowSelect({ selectedRow })}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            variant="contained"
            color="primary"
            onClick={(e) => {
              e.preventDefault();
              handleAdd(rowSelect.selectedRow);

              setRowSelect({
                tableRef: createRef(),
                selected: true,
                selectedRowId: null,
                c: "blue",
                currentRow: {},
              });

              handleClose();
            }}
          >
            <SaveIcon />
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
